"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoveModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
var _usePostValidateDuplications = require("api/usePostValidateDuplications");
var _Alerts = require("components/shared/Alerts/Alerts");
var _SearchField = _interopRequireDefault(require("components/shared/SearchField/SearchField"));
var _DocumentGridBreadcrumb = _interopRequireDefault(require("pages/DocumentManagementView/DocumentGridBreadcrumb"));
var _reactRouterDom = require("react-router-dom");
var _constants = require("util/constants");
var _CreateFolderStep = _interopRequireDefault(require("../UploadFile/CreateFolderStep"));
var _useDeleteBlob = require("@/api/useDeleteBlob");
var _DocumentIcon = require("@/components/DocumentManagementView/DocumentGrid/DocumentIcon");
var _CustomGrid = _interopRequireDefault(require("@/components/shared/CustomGrid/CustomGrid"));
var _axios = _interopRequireDefault(require("@/configs/axios"));
var _DocumentGrid = require("@/pages/DocumentManagementView/DocumentGrid.utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var MoveModal = exports.MoveModal = function MoveModal(_ref) {
  var _currentPath$at$id, _currentPath$at;
  var callbackClose = _ref.callbackClose,
    selectedDocuments = _ref.selectedDocuments,
    availableFolders = _ref.availableFolders,
    currentPath = _ref.currentPath;
  var _useState = (0, _react.useState)(availableFolders || []),
    _useState2 = _slicedToArray(_useState, 2),
    originalAvailableFolders = _useState2[0],
    setOriginalAvailableFolders = _useState2[1];
  var _usePostValidateDupli = (0, _usePostValidateDuplications.usePostValidateDuplications)({}),
    callValidateDuplicate = _usePostValidateDupli.mutateAsync;

  // Helper functions
  var hasTeamsSource = function hasTeamsSource(doc) {
    return doc.source === _constants.SOURCE_TEAMS;
  };
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    originalTree = _useState4[0],
    setOriginalTree = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = (0, _react.useState)(_constants.AlertColor.Info),
    _useState8 = _slicedToArray(_useState7, 2),
    alertColor = _useState8[0],
    setAlertColor = _useState8[1];
  var _useState9 = (0, _react.useState)(""),
    _useState0 = _slicedToArray(_useState9, 2),
    alertMessage = _useState0[0],
    setAlertMessage = _useState0[1];
  var _useState1 = (0, _react.useState)(""),
    _useState10 = _slicedToArray(_useState1, 2),
    searchText = _useState10[0],
    setSearchText = _useState10[1];
  var _useState11 = (0, _react.useState)(currentPath),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedPath = _useState12[0],
    setSelectedPath = _useState12[1];
  var _useState13 = (0, _react.useState)(currentPath.length === 0 ? null : (_currentPath$at$id = (_currentPath$at = currentPath.at(-1)) === null || _currentPath$at === void 0 ? void 0 : _currentPath$at.id) !== null && _currentPath$at$id !== void 0 ? _currentPath$at$id : null),
    _useState14 = _slicedToArray(_useState13, 2),
    parentId = _useState14[0],
    setParentId = _useState14[1];
  var _usePostDeleteBlobs = (0, _useDeleteBlob.usePostDeleteBlobs)(),
    callDeleteBlobs = _usePostDeleteBlobs.mutateAsync;
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    duplicatedFiles = _useState16[0],
    setDuplicatedFiles = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    createFolder = _useState18[0],
    setCreateFolder = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    folderExists = _useState20[0],
    setFolderExists = _useState20[1];
  var _useState21 = (0, _react.useState)(""),
    _useState22 = _slicedToArray(_useState21, 2),
    folderValue = _useState22[0],
    setFolderValue = _useState22[1];
  var theme = (0, _material.useTheme)();
  // Filter documents based on parentId and search text, similar to DocumentsGrid
  var allGridRows = originalTree.filter(function (doc) {
    return doc.parentId === parentId && !selectedDocuments.some(function (selected) {
      return selected.id === doc.id;
    });
  });

  // Apply search filter if there's search text
  var filteredDocuments = searchText ? allGridRows.filter(function (file) {
    return file.documentName.toLowerCase().includes(searchText.toLowerCase());
  }) : allGridRows;
  var columns = [{
    renderCell: function renderCell(params) {
      var duplicated = duplicatedFiles.find(function (d) {
        return d === params.row.documentName;
      });
      return /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: !duplicated && params ? params.row.documentName : null,
        arrow: true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex align-items-center gap-8"
      }, /*#__PURE__*/_react["default"].createElement(_DocumentIcon.DocumentIcon, {
        fileType: params.row.fileType
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        style: {
          color: params.row.fileType === _constants.TYPE_FOLDER ? theme.palette.primary.main : "#515152",
          textDecoration: "none",
          maxWidth: "80%",
          cursor: params.row.fileType === _constants.TYPE_FOLDER ? "pointer" : "default"
        },
        className: "text-overflow-ellipsis",
        "data-testid": "link-".concat(params.row.documentName),
        to: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          handleColumnNameClick(params.row);
        },
        onContextMenu: function onContextMenu(e) {
          e.preventDefault();
          handleColumnNameClick(params.row);
        },
        onMouseDown: function onMouseDown(e) {
          if (e.button === 1) {
            // Detection of the mouse scroll button
            handleColumnNameClick(params.row);
          }
        },
        target: "_blank"
      }, params.row.documentName), hasTeamsSource(params.row) && /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
        icon: "logos:microsoft-teams",
        width: 15,
        height: 15
      }), duplicated && /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: _constants.OVERRIDE_MESSAGE,
        arrow: true
      }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
        icon: "ep:warning-filled",
        height: 15,
        style: {
          color: "black",
          marginLeft: "10px"
        },
        "aria-label": "Warning: ".concat(params.row.documentName, " will be override.")
      }))));
    },
    headerName: "Document name",
    flex: 1.5,
    field: "documentName"
  }, {
    field: "category",
    headerName: "Category",
    flex: 1
  }, {
    field: "fileType",
    headerName: "File type",
    flex: 0.5,
    renderCell: function renderCell(params) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "fileType_bullet_container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "fileType_bullet ".concat(params.row.fileType == _constants.TYPE_FOLDER ? "folder" : "file")
      }, params.row.fileType));
    }
  }, {
    field: "source",
    headerName: "Source",
    flex: 0.5
  }, {
    field: "uploaded",
    headerName: "Uploaded",
    flex: 1
  }, {
    field: "uploadedBy",
    headerName: "Uploaded by",
    flex: 1
  }];
  var handleColumnNameClick = function handleColumnNameClick(blob) {
    if (blob.fileType == _constants.TYPE_FOLDER) {
      //Just add information to the breadcrumb
      setSelectedPath([].concat(_toConsumableArray(selectedPath), [{
        id: blob.id,
        name: blob.documentName
      }]));
    }
  };
  var _addToRequest = function addToRequest(attributes, files, folder) {
    files.forEach(function (file) {
      if (file.fileType === _constants.TYPE_FOLDER) {
        // Get all children from the flat structure using the new utility function
        var children = (0, _DocumentGrid.getDocumentsWithChildren)([file.id], (0, _DocumentGrid.getBlobTree)(originalAvailableFolders)).filter(function (child) {
          return child.id !== file.id;
        } // Exclude the parent folder itself
        );
        _addToRequest(attributes, children, folder + file.documentName + "/");
      } else if (!Object.hasOwn(attributes, file.fileAlias)) {
        var _file$metadata;
        attributes[file.fileAlias] = {
          category: file.category,
          metadata: (_file$metadata = file.metadata) !== null && _file$metadata !== void 0 ? _file$metadata : "",
          path: folder,
          fileName: file.documentName,
          uuid: file.uuid
        };
      }
    });
  };
  var validateDuplication = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(attributes) {
      var keys, validationResults;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            keys = Object.keys(attributes);
            _context.next = 3;
            return callValidateDuplicate({
              fileNames: keys.map(function (k) {
                return attributes[k].fileName;
              }),
              path: attributes[keys[0]].path
            });
          case 3:
            validationResults = _context.sent;
            return _context.abrupt("return", validationResults);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function validateDuplication(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var moveToFolder = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var attributes, duplications, duplicated, filesToRemove, url, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsLoading(true);
            attributes = {};
            _addToRequest(attributes, selectedDocuments, selectedPath.length > 0 ? selectedPath.map(function (p) {
              return p.name;
            }).join("/") + "/" : "");
            _context2.prev = 3;
            if (!(duplicatedFiles.length === 0)) {
              _context2.next = 16;
              break;
            }
            _context2.next = 7;
            return validateDuplication(attributes);
          case 7:
            duplications = _context2.sent;
            duplicated = duplications.filter(function (d) {
              return d.exists;
            }).map(function (d) {
              return d.name;
            });
            if (!(duplicated.length > 0)) {
              _context2.next = 16;
              break;
            }
            setSelectedPath(attributes[Object.keys(attributes)[0]].path.split("/").filter(function (p) {
              return p !== "";
            }));
            setAlertColor(_constants.AlertColor.Warning);
            setAlertMessage("A file with the same name already exists in the selected location. Select Continue to overwrite the existing file.");
            setDuplicatedFiles(duplicated);
            setIsLoading(false);
            return _context2.abrupt("return", false);
          case 16:
            //Need to remove the duplicated files
            filesToRemove = filteredDocuments.filter(function (d) {
              return duplicatedFiles.find(function (dF) {
                return dF === d.documentName;
              });
            }).map(function (f) {
              return f.fileAlias;
            });
            if (!(filesToRemove.length > 0)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 20;
            return callDeleteBlobs(filesToRemove);
          case 20:
            url = "".concat(process.env.REACT_APP_SERVER_HOST, "/update");
            _context2.next = 23;
            return _axios["default"].patch(url, {
              blobs: attributes,
              category_updated: false
            }, {
              headers: {
                "Cache-Control": "no-store"
              }
            });
          case 23:
            response = _context2.sent;
            if (response.status == 200) {
              callbackClose(true);
            }
            _context2.next = 31;
            break;
          case 27:
            _context2.prev = 27;
            _context2.t0 = _context2["catch"](3);
            setAlertColor(_constants.AlertColor.Error);
            setAlertMessage(_context2.t0.message || "Unexpected error while calling the API.");
          case 31:
            setIsLoading(false);
          case 32:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 27]]);
    }));
    return function moveToFolder() {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    var _selectedPath$at$id, _selectedPath$at;
    setParentId(selectedPath.length === 0 ? null : (_selectedPath$at$id = (_selectedPath$at = selectedPath.at(-1)) === null || _selectedPath$at === void 0 ? void 0 : _selectedPath$at.id) !== null && _selectedPath$at$id !== void 0 ? _selectedPath$at$id : null);
  }, [selectedPath]);
  (0, _react.useEffect)(function () {
    setOriginalTree((0, _DocumentGrid.getBlobTree)(originalAvailableFolders).filter(function (d) {
      return !selectedDocuments.some(function (sD) {
        return sD.id === d.id;
      });
    }));
  }, [originalAvailableFolders, selectedDocuments]);
  var getMoveButtonContent = function getMoveButtonContent() {
    if (isLoading) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          padding: "0 10px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
        size: 15
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          marginLeft: 10
        }
      }, "Moving..."));
    }
    if (duplicatedFiles.length > 0) {
      return "Continue moving";
    }
    return "Move here";
  };
  var isDisabledMoveButton = function isDisabledMoveButton() {
    if (isLoading) {
      return true;
    }
    var selectedPathJoined = selectedPath.length > 0 ? selectedPath.map(function (p) {
      return p.name;
    }).join("/") + "/" : "";
    var currentPathJoined = currentPath.length > 0 ? currentPath.map(function (p) {
      return p.name;
    }).join("/") + "/" : "";
    return currentPathJoined === selectedPathJoined;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Modal, {
    open: true,
    onClose: function onClose(e) {
      if (e.key !== "Escape") {
        callbackClose(false);
      }
    },
    "data-testid": "moveModalFiles",
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-content",
    style: {
      height: "auto",
      width: "80vw",
      borderRadius: "4px",
      maxHeight: "90vh",
      overflowY: "auto"
    },
    "data-testid": "moveModal"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-header"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return callbackClose(false);
    },
    className: "close_icon"
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "bitcoin-icons:cross-filled",
    height: 30,
    color: "#000000"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "upload_title"
  }, "Move to"), /*#__PURE__*/_react["default"].createElement("span", null, "Move selected item(s) to desired folder."))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex content_menu align-items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-bar-container"
  }, /*#__PURE__*/_react["default"].createElement(_SearchField["default"], {
    searchText: searchText,
    setSearchText: setSearchText
  })), createFolder && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-15"
  }, /*#__PURE__*/_react["default"].createElement(_CreateFolderStep["default"], {
    folderPath: folderValue,
    onKeyDownCallback: function onKeyDownCallback(e) {
      if (e.key === "Escape") {
        setCreateFolder(false);
        setFolderValue("");
      } else if (e.key === "Enter" && !folderExists) {
        // Calculate current parent ID based on selectedPath
        var currentParentId = null;
        var _iterator = _createForOfIteratorHelper(selectedPath),
          _step;
        try {
          var _loop = function _loop() {
            var pathSegment = _step.value;
            var foundFolder = originalTree.find(function (doc) {
              return doc.documentName === pathSegment.name && doc.parentId === currentParentId && doc.fileType === _constants.TYPE_FOLDER;
            });
            if (foundFolder) {
              currentParentId = foundFolder.id;
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        setOriginalAvailableFolders([].concat(_toConsumableArray(originalAvailableFolders), [{
          documentName: folderValue,
          file_name: folderValue,
          indexing_status: "SUCCESS",
          fileType: _constants.TYPE_FOLDER,
          category: "",
          id: "folder-".concat(selectedPath.map(function (p) {
            return p.id;
          }).join("-"), "-").concat(folderValue),
          metadata: "",
          path: selectedPath.length > 0 ? selectedPath.map(function (p) {
            return p.name;
          }).join("/") + "/" : "",
          previewUrl: "",
          uploaded: new Date().toISOString(),
          uploadedBy: "",
          url: "",
          fileAlias: "",
          folderSource: "",
          source: "",
          file_extension: "1.".concat(_constants.TYPE_FOLDER),
          uuid: "folder-".concat(folderValue),
          parentId: currentParentId
        }]));
        setCreateFolder(false);
        setFolderValue("");
      }
    },
    onChangeCallback: function onChangeCallback(e) {
      var value = e.target.value;

      // Navigate through the flat structure using parentId relationships
      var currentParentId = null;
      var folderExists = false;

      // First navigate through selectedPath to get the current parent
      var _iterator2 = _createForOfIteratorHelper(selectedPath),
        _step2;
      try {
        var _loop2 = function _loop2() {
          var pathSegment = _step2.value;
          var foundFolder = originalTree.find(function (doc) {
            return doc.documentName.trim() === pathSegment.name.trim() && doc.parentId === currentParentId && doc.fileType === _constants.TYPE_FOLDER;
          });
          if (foundFolder) {
            currentParentId = foundFolder.id;
          } else {
            return 1; // break
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          if (_loop2()) break;
        }

        // Now check if the new folder name already exists at this location
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var existingFolder = originalTree.find(function (doc) {
        return doc.documentName.trim() === value.trim() && doc.parentId === currentParentId && doc.fileType === _constants.TYPE_FOLDER;
      });
      folderExists = !!existingFolder;
      setFolderValue(value);
      setFolderExists(folderExists);
      return folderExists;
    }
  })), !createFolder && /*#__PURE__*/_react["default"].createElement("button", {
    className: "upload_btn",
    onClick: function onClick() {
      return setCreateFolder(true);
    },
    "data-testid": "createFolderButton"
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "ph:folder-simple-plus-light",
    width: 18,
    height: 18
  }), "Create folder")), /*#__PURE__*/_react["default"].createElement(_DocumentGridBreadcrumb["default"], {
    breadcrumbs: selectedPath,
    clickOnPathCallback: setSelectedPath,
    disabled: duplicatedFiles.length > 0
  }), /*#__PURE__*/_react["default"].createElement(_CustomGrid["default"], {
    style: {
      maxHeight: "50vh",
      minHeight: "40vh",
      overflow: "visible"
    },
    rows: filteredDocuments,
    columns: columns,
    allRows: originalTree,
    keepNonExistentRowsSelected: true,
    pageSizeOptions: [5, 10, 50, 100],
    disableRowSelectionOnClick: true,
    classes: {
      footerContainer: "footer"
    },
    localeText: {
      MuiTablePagination: {
        labelRowsPerPage: "Items per page:"
      }
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-footer"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "save_btn",
    onClick: moveToFolder,
    disabled: isDisabledMoveButton(),
    "data-testid": "moveModal-moveButton"
  }, getMoveButtonContent()), /*#__PURE__*/_react["default"].createElement("button", {
    className: "cancel_btn",
    onClick: function onClick() {
      if (duplicatedFiles.length > 0) {
        setDuplicatedFiles([]);
        setSelectedPath(selectedPath.slice(0, selectedPath.length - 1));
      } else {
        callbackClose(false);
      }
    },
    "data-testid": "moveModal-cancelButton"
  }, "Cancel")))), /*#__PURE__*/_react["default"].createElement(_Alerts.Alerts, {
    style: {
      top: "",
      right: "",
      left: ""
    },
    alertOpen: alertMessage !== "",
    color: alertColor,
    message: alertMessage,
    handleAlertClose: function handleAlertClose() {
      return setAlertMessage("");
    }
  }));
};